import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from '@apollo/client';
import { Typography } from '@guildeducationinc/recess';
import { CountrySelect } from '@src/components/CountrySelect';
import { prepareForSave } from '@src/utilities/gqlHelper';
import { CLIENT_CONFIG, CurrencySelect, MuiSingleSelect, SAVE_CLIENT_CONFIG, SUPPORTED_LOCALES, TimezoneSelect, TrackableButton, useAlert, useLocale, } from 'pe-core-frontend';
import { useMemo, useState } from 'react';
export const EditClientConfig = ({ clientConfig }) => {
    const { showAlert } = useAlert();
    const { t } = useLocale();
    const [errors, setErrors] = useState({});
    const [saveClientConfig] = useMutation(SAVE_CLIENT_CONFIG, {
        refetchQueries: [{ query: CLIENT_CONFIG, variables: { clientId: clientConfig.clientId } }],
    });
    const [draft, setDraft] = useState(clientConfig);
    const localeOptions = useMemo(() => SUPPORTED_LOCALES.map(locale => ({
        label: locale.name,
        value: locale.locale,
    })), []);
    const validate = () => {
        const errors = {};
        if (!draft.locale) {
            errors.locale = t('Please choose a default email language');
        }
        if (!draft.currency) {
            errors.currency = t('Please select a currency code');
        }
        if (!draft.timezone) {
            errors.timezone = t('Please select a timezone');
        }
        if (!draft.country) {
            errors.country = t('Please select a country');
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const handleSave = async () => {
        try {
            if (!validate())
                return;
            await saveClientConfig({
                variables: {
                    input: {
                        ...prepareForSave(draft),
                        clientId: draft.clientId,
                        id: draft.id ? draft.id : undefined,
                    },
                },
            });
            showAlert(t('Client config saved'));
        }
        catch (e) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            showAlert(e.message, 'error');
        }
    };
    const handleCurrencyChange = (currency) => {
        setDraft({ ...draft, currency });
    };
    const handleTimezoneChange = (timezone) => {
        setDraft({ ...draft, timezone });
    };
    const handleDefaultEmailLanguageChange = (e) => {
        const selection = e.selection;
        setDraft({ ...draft, locale: selection?.value ? String(selection.value) : '' });
    };
    const handleCountryChange = (country) => {
        setDraft({ ...draft, country });
    };
    return (_jsxs("div", { children: [_jsxs("div", { className: 'flex', children: [_jsxs("div", { className: 'w-1/2', children: [_jsxs("div", { className: 'margin--top_16', children: [_jsx(Typography, { variant: 'label1', className: 'margin--bottom_8', children: t('Country') }), _jsx(CountrySelect, { value: draft.country, onChange: handleCountryChange, errors: errors.country })] }), _jsx(TimezoneSelect, { className: 'margin--top_16', value: draft.timezone, onChange: handleTimezoneChange, errors: errors.timezone }), _jsx(CurrencySelect, { className: 'margin--top_16 max-w-md', value: draft.currency, onChange: handleCurrencyChange, errors: errors.currency })] }), _jsx("div", { className: 'w-1/2', children: _jsx(MuiSingleSelect, { className: 'max-w-md', label: t('Default Language'), options: localeOptions, value: draft.locale || '', onChange: handleDefaultEmailLanguageChange, errors: errors.locale, required: true }) })] }), _jsx("div", { className: 'actions margin--top_16', children: _jsx(TrackableButton, { btnType: 'mui', enText: 'Save', tag: 'form', variant: 'contained', onClick: handleSave, className: 'margin--right_24', children: t('Save') }) })] }));
};
